import React from 'react'
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/table'
import { tableHeadClass, tableCellClass, tableCellLastRowClass } from '@/components/ui/table-styles'
import DirhamsIcon from '@/components/ui/dirhams-icon'
import { cn } from '@/lib/utils'
import OrderedBadge from '@/routes/(inventory)/-module-components/badges/ordered'
import { PurchaseOrderItemResponse } from '@/gen/purchase_order/common_pb'
import { InventoryLineItem } from '@/gen/inventory/common_pb'
import { PurchaseRequestLineItem } from '@/gen/purchase_request/common_pb'
import { convertToCurrencyRounded } from '@/utils/currency_converter'
import ReceivedBadge from '@/routes/(inventory)/-module-components/badges/received'
import dayjs from 'dayjs'
import { Supplier } from '@/gen/suppliers/common_pb'
import NotReceivedBadge from '@/routes/(inventory)/-module-components/badges/not-received'
import InProgressBadge from '@/routes/(inventory)/-module-components/badges/in-progress'

const StocksTab = ({
  poItems,
  prItems,
  inventoryItems,
  supplierInfo
}: {
  poItems?: PurchaseOrderItemResponse[]
  prItems?: PurchaseRequestLineItem[]
  inventoryItems?: InventoryLineItem[]
  supplierInfo: Supplier
}) => {
  return (
    <div className="w-full h-full flex flex-col items-stretch justify-start">
      <div className="bg-white overflow-hidden">
        <div className='w-full p-2 bg-[#FBFBFB] border-y-[1px]'>
          {poItems && <OrderedBadge />}
          {inventoryItems && <ReceivedBadge />}
          {prItems && <InProgressBadge />}
        </div>
        <Table className="text-sm mt-4">
          <TableHeader>
            <TableRow className="text-sm">
              <TableHead className={tableHeadClass}>SL NO.</TableHead>
              <TableHead className={tableHeadClass}>Product Name</TableHead>
              <TableHead className={tableHeadClass}>Batch</TableHead>
              <TableHead className={tableHeadClass}>Barcode</TableHead>
              <TableHead className={tableHeadClass}>Expiry Date</TableHead>
              <TableHead className={tableHeadClass}>Bonus</TableHead>
              <TableHead className={tableHeadClass}>Quantity</TableHead>
              <TableHead className={tableHeadClass}>Cost</TableHead>
              <TableHead className={tableHeadClass}>Gross</TableHead>
              <TableHead className={tableHeadClass}>Tax</TableHead>
              <TableHead className={tableHeadClass}>Net</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {prItems?.map((item, idx) => (
              <TableRow className="font-medium" key={idx}>
                <TableCell className={tableCellClass}>{idx + 1}</TableCell>
                <TableCell className={tableCellClass}>{item.tradeName}</TableCell>
                <TableCell className={tableCellClass}>{"N/A"}</TableCell>
                <TableCell className={tableCellClass}>{"N/A"}</TableCell>
                <TableCell className={tableCellClass}>{"N/A"}</TableCell>
                <TableCell className={tableCellClass}>{'0'}</TableCell>
                <TableCell className={tableCellClass}>{item.quantity}</TableCell>
                <TableCell className={tableCellClass}>{
                    'N/A'
                  }</TableCell>
                <TableCell className={tableCellClass}>{
                    'N/A'
                  }</TableCell>
                <TableCell className={tableCellClass}>{
                    'N/A'
                  }</TableCell>
                <TableCell className={tableCellClass}>{'N/A'}</TableCell>
              </TableRow>
            ))}
            {poItems?.map((item, idx) => (
              <TableRow className="font-medium" key={idx}>
                <TableCell className={tableCellClass}>{idx + 1}</TableCell>
                <TableCell className={tableCellClass}>{item.tradeName}</TableCell>
                <TableCell className={tableCellClass}>{"N/A"}</TableCell>
                <TableCell className={tableCellClass}>{"N/A"}</TableCell>
                <TableCell className={tableCellClass}>{"N/A"}</TableCell>
                <TableCell className={tableCellClass}>{item.bonusQuantity}</TableCell>
                <TableCell className={tableCellClass}>{item.quantity}</TableCell>
                <TableCell className={tableCellClass}>{
                    convertToCurrencyRounded(item.unitPrice)
                  }</TableCell>
                <TableCell className={tableCellClass}>{
                    convertToCurrencyRounded(item.unitPrice * item.quantity)
                  }</TableCell>
                <TableCell className={tableCellClass}>{
                    convertToCurrencyRounded(
                      (
                        item.taxProfile!.applicableTaxes.filter(item => {
                            const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                            if (countryCode === 'IN') {
                                return item.componentCode.includes('GST');
                            } else if (countryCode === 'AE') {
                                return item.componentCode.includes('VAT');
                            }
                            return false;
                        }).reduce((acc, tax) => {
                            const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                            if (countryCode === 'IN') {
                                const pharmacyState = localStorage.getItem('pharmacyLocationDetails') ? JSON.parse(localStorage.getItem('pharmacyLocationDetails') || '{}').state : '';
                                if (supplierInfo.metadata?.isSez || pharmacyState === supplierInfo.metadata?.state) {
                                  if (tax.componentCode.includes('CGST') || tax.componentCode.includes('SGST')) {
                                      return acc + (tax.ratePercent / 100) * item.unitPrice;
                                  }
                                } else {
                                  if (tax.componentCode.includes('IGST')) {
                                      return acc + (tax.ratePercent / 100) * item.unitPrice;
                                  }
                                }
                            } else if (countryCode === 'AE') {
                                return acc + (tax.ratePercent / 100) * item.unitPrice;
                            }
                            return acc;
                        }, 0) * item.quantity!
                    )
                    )
                  }</TableCell>
                <TableCell className={tableCellClass}>{convertToCurrencyRounded(
                    item.quantity * item.unitPrice + 
                    (
                        item.taxProfile!.applicableTaxes.filter(item => {
                            const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                            if (countryCode === 'IN') {
                                return item.componentCode.includes('GST');
                            } else if (countryCode === 'AE') {
                                return item.componentCode.includes('VAT');
                            }
                            return false;
                        }).reduce((acc, tax) => {
                            const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                            if (countryCode === 'IN') {
                                const pharmacyState = localStorage.getItem('pharmacyLocationDetails') ? JSON.parse(localStorage.getItem('pharmacyLocationDetails') || '{}').state : '';
                                if (supplierInfo.metadata?.isSez || pharmacyState === supplierInfo.metadata?.state) {
                                  if (tax.componentCode.includes('CGST') || tax.componentCode.includes('SGST')) {
                                      return acc + (tax.ratePercent / 100) * item.unitPrice;
                                  }
                                } else {
                                  if (tax.componentCode.includes('IGST')) {
                                      return acc + (tax.ratePercent / 100) * item.unitPrice;
                                  }
                                }
                            } else if (countryCode === 'AE') {
                                return acc + (tax.ratePercent / 100) * item.unitPrice;
                            }
                            return acc;
                        }, 0) * item.quantity!
                    )
                )}</TableCell>
              </TableRow>
            ))}
            {inventoryItems?.map((item, idx) => (
              <TableRow className="font-medium" key={idx}>
                <TableCell className={tableCellClass}>{idx + 1}</TableCell>
                <TableCell className={tableCellClass}>{item.tradeName}</TableCell>
                <TableCell className={tableCellClass}>{item.batchNumber}</TableCell>
                <TableCell className={tableCellClass}>{item.barcode}</TableCell>
                <TableCell className={tableCellClass}>{dayjs(item.expiryDate?.toDate()).format("DD/MM/YYYY")}</TableCell>
                <TableCell className={tableCellClass}>{item.inputQuantity?.bonus}</TableCell>
                <TableCell className={tableCellClass}>{item.inputQuantity?.original}</TableCell>
                <TableCell className={tableCellClass}>{
                    convertToCurrencyRounded(item.costFromSupplier)
                  }</TableCell>
                <TableCell className={tableCellClass}>{
                    convertToCurrencyRounded(item.costFromSupplier * item.inputQuantity?.original!)
                  }</TableCell>
                <TableCell className={tableCellClass}>{
                    convertToCurrencyRounded(
                        // Calculate only the tax on the cost from supplier
                        (
                        item.taxProfile!.applicableTaxes.filter(item => {
                            const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                            if (countryCode === 'IN') {
                                return item.componentCode.includes('GST');
                            } else if (countryCode === 'AE') {
                                return item.componentCode.includes('VAT');
                            }
                            return false;
                        }).reduce((acc, tax) => {
                            const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                            if (countryCode === 'IN') {
                                const pharmacyState = localStorage.getItem('pharmacyLocationDetails') ? JSON.parse(localStorage.getItem('pharmacyLocationDetails') || '{}').state : '';
                                if (supplierInfo.metadata?.isSez || pharmacyState === supplierInfo.metadata?.state) {
                                  if (tax.componentCode.includes('CGST') || tax.componentCode.includes('SGST')) {
                                      return acc + (tax.ratePercent / 100) * item.costFromSupplier;
                                  }
                                } else {
                                  if (tax.componentCode.includes('IGST')) {
                                      return acc + (tax.ratePercent / 100) * item.costFromSupplier;
                                  }
                                }
                            } else if (countryCode === 'AE') {
                                return acc + (tax.ratePercent / 100) * item.costFromSupplier;
                            }
                            return acc;
                        }, 0) * item.inputQuantity?.original!
                    )
                    )
                  }</TableCell>
                <TableCell className={tableCellClass}>{convertToCurrencyRounded(
                    item.inputQuantity?.original! * item.costFromSupplier + 
                    (
                        item.taxProfile!.applicableTaxes.filter(item => {
                            const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                            if (countryCode === 'IN') {
                                return item.componentCode.includes('GST');
                            } else if (countryCode === 'AE') {
                                return item.componentCode.includes('VAT');
                            }
                            return false;
                        }).reduce((acc, tax) => {
                            const countryCode = localStorage.getItem('pharmacyMetadata') ? JSON.parse(localStorage.getItem('pharmacyMetadata') || '{}').countryCode : 'IN';
                            if (countryCode === 'IN') {
                                const pharmacyState = localStorage.getItem('pharmacyLocationDetails') ? JSON.parse(localStorage.getItem('pharmacyLocationDetails') || '{}').state : '';
                                if (supplierInfo.metadata?.isSez || pharmacyState === supplierInfo.metadata?.state) {
                                  if (tax.componentCode.includes('CGST') || tax.componentCode.includes('SGST')) {
                                      return acc + (tax.ratePercent / 100) * item.costFromSupplier;
                                  }
                                } else {
                                  if (tax.componentCode.includes('IGST')) {
                                      return acc + (tax.ratePercent / 100) * item.costFromSupplier;
                                  }
                                }
                            } else if (countryCode === 'AE') {
                                return acc + (tax.ratePercent / 100) * item.costFromSupplier;
                            }
                            return acc;
                        }, 0) * item.inputQuantity?.original!
                    )
                )}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default StocksTab 